import { useTypedParams } from '@sorare/routing';

import { MissionsPageLayout } from '@sorare/gameplay/src/pages/MissionsPageLayout';

import { PageParams } from './__generated__/routeParams';

const FootballMissionsCategoryLayout = () => {
  const { category, rarity } = useTypedParams<PageParams>();
  return <MissionsPageLayout rarity={rarity} category={category} />;
};

export default FootballMissionsCategoryLayout;
